import React, { useEffect, useState } from 'react'
import { api } from '../../../app/Api/ApiSlice'
import { useNavigate, useParams } from 'react-router-dom'
import { toast } from 'react-toastify'
import Loader from '../../../components/Loader'
import { FaPen, FaPlus, FaTimes } from 'react-icons/fa'
import "../storesStyles.css"


const StoreShelves = () => {
    const [storeShelves, setStoreShelves] = useState([])
    const [isLoading, setIsLoading] = useState(false)
    const [modalOpen, setModalOpen] = useState(false)

    const [shelfName, setShelfName] = useState("")
    const [shelfDescription, setShelfDescription] = useState("")
    const [creating, setCreating] = useState(false)

    const { name } = useParams()
    const navigate = useNavigate()

    useEffect(() => {
        const getShelves = async () => {
            try {
                setIsLoading(true)
                const response = await api.get(`/stores/${name}/manage/shelves`)
                if (response) {
                    setStoreShelves(response.data)
                }
            } catch (error) {
                toast.error(error.response.data.message)
            }
            finally {
                setIsLoading(false)
            }
        }

        getShelves()
    }, [])

    const handleSubmit = async (e) => {
        e.preventDefault()

        const newShelf = { name: shelfName, description: shelfDescription }
        try {
            setCreating(true)
            const response = await api.post(`stores/${name}/manage/shelves`, { newShelf })
            if (response) {
                setStoreShelves((prev)=>[...prev,response.data])
                toast.success("shelf created")
                setShelfName("")
                setShelfDescription("")
                setModalOpen(false)
            }
        } catch (error) {
            toast.error(error.response.data.message)
        }
        finally {
            setCreating(false)
        }
    }
    return (
        <div className='shelves-container'>
            <div className={modalOpen ? "modal-open" : "modal-close"}>
                <div className="modal-close-btn">
                    <FaTimes onClick={() => setModalOpen(false)} />
                </div>
                <div className="modal-create-form">
                    <form onSubmit={handleSubmit}>
                        <h3 className="modal-title">Create New Shelf</h3>
                        <label htmlFor="name">Name</label>
                        <input
                            type="text"
                            required={true}
                            placeholder='products shelf name'
                            onChange={(e) => setShelfName(e.target.value)}
                        />
                        <label htmlFor="description">Description</label>
                        <input
                            type="text"
                            required={true}
                            placeholder='Shelf description'
                            onChange={(e) => setShelfDescription(e.target.value)}
                        />
                        <button>{creating?"Loading...":"Save"}</button>
                    </form>
                </div>
            </div>
            <div className="shelves-header">
                <h2>{name}  Shelves</h2>
                <div className='header-add-btn'>
                    <FaPlus onClick={() => setModalOpen(true)} />
                </div>
            </div>
            {isLoading && <Loader />}
            {
                storeShelves.map((shelf) => (
                    <div className="shelf">
                        <div className="shelf-info">
                            <h3>{shelf.name}</h3>
                            <p>{shelf.description}</p>
                            <br />
                            <p>Products:{shelf.productsCount || 0}</p>
                        </div>
                        <div className="shelf-btns">
                            <button onClick={()=>navigate(`/b/manage/${name}/shelves/${shelf.name}`,{state:{id:shelf._id}})}>Products</button>
                            <button onClick={()=>navigate(`/b/manage/${name}/shelves/${shelf.name}/edit`,{state:{id:shelf._id}})}><FaPen/></button>
                        </div>
                    </div>
                ))
            }
        </div>
    )
}

export default StoreShelves